// @flow
import React, { Component } from 'react';
import {
  CommissionsDiv,
  ViewMoreLink,
  ViewMoreLinkDiv,
  NoCommissionDiv,
  CurrencyDetailSpacerDiv
} from './CommissionsStyles';
import { type CommissionStat } from '..';
import CurrencyDetail from './CurrencyDetail';
import { type Currencies } from '../../../../utilities/types';
import noCommissionImg from '../../../../assets/images/girl-shrug.jpg';
import { DefaultIcon } from '../../../../components/Icon';
type Props = {
  commissions: CommissionStat[],
  currencies: Currencies
};

export default class Commissions extends Component<Props> {
  render() {
    if (this.props.commissions.length === 0) {
      return (
        <NoCommissionDiv>
          <img src={noCommissionImg} alt="" />
          <p>No Commission Earned Yet...</p>
        </NoCommissionDiv>
      );
    }
    return (
      <CommissionsDiv>
        {this.props.commissions.map(commission => (
          <CurrencyDetail
            key={commission.currency}
            {...commission}
            currencies={this.props.currencies}
          />
        ))}
        <ViewMoreLinkDiv>
          <ViewMoreLink to="/commission-payouts/due">
            View Details <DefaultIcon name="arrowRightSlim" colorName="blue" />
          </ViewMoreLink>
        </ViewMoreLinkDiv>
        {this.props.commissions.length === 1 && <CurrencyDetailSpacerDiv />}
      </CommissionsDiv>
    );
  }
}
